export default function (bowser) {
  if (bowser.ios || bowser.blackberry) {
    return bowser.name;
  } else if (bowser.android) {
    return 'Android';
  } else if (bowser.windowsphone) {
    return 'Windows Mobile';
  }
  return 'PC';
}
